import { Checkbox } from '@mui/material';
import React, { useState } from 'react';
import Legend from './Legend';
import IconButton from '../button/IconButton';
import './LegendPopup.css';
import { useAtomValue, useSetAtom } from 'jotai';
import { isLegendControlOpenAtom, isSeparateDisplayControllerAtom, sidebarHeightAtom } from '../../atoms';
import classNames from 'classnames';
import { MAIN_MAP_ID, SECOND_MAP_ID } from '../../constants/components/map';

const MIN_LEGEND_HEIGHT = 250;

type LegendPopupProps = {
    remainingHeight?: number;
    mapType?: typeof SECOND_MAP_ID | typeof MAIN_MAP_ID;
};
const LegendPopup: React.FC<LegendPopupProps> = ({ remainingHeight, mapType }) => {
    
    const [isFliterLayers, setIsFliterLayers] = useState<boolean>(true);

    const setIsLegendControlOpen = useSetAtom(isLegendControlOpenAtom);     // 凡例表示フラグ
    const setSidebarHeight = useSetAtom(sidebarHeightAtom);
    const isSeparateDisplayController = useAtomValue(isSeparateDisplayControllerAtom);
    
    const handleClose = () => {
        setSidebarHeight('close');
        setIsLegendControlOpen(false);
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsFliterLayers(event.target.checked);
    };

    if (remainingHeight !== undefined && remainingHeight < MIN_LEGEND_HEIGHT) {
        remainingHeight = MIN_LEGEND_HEIGHT;
    }

    return (
        <div className={classNames('legend-popup-wrapper', { 'small': isSeparateDisplayController })} style={{ maxHeight: remainingHeight??'auto' }}>
            <div className='legend-popup'>
                <div className='legend-popup-close-btn-wrapper'>
                    <IconButton icon='close' onClick={handleClose} />
                </div>
                <div className='legend-popup-title'>
                    <h2>データの凡例</h2>
                    <label className='legend-popup-checkbox'>
                        <Checkbox
                            checked={isFliterLayers}
                            onChange={handleCheckboxChange}
                            name="showAllLayers"
                            color="primary"
                        />
                        <span>表示中データの凡例のみ表示</span>
                    </label>
                </div>
                <div className='legend-popup-content' style={remainingHeight ? { maxHeight: remainingHeight - 117} : {}}>
                    <Legend isAllLayers={!isFliterLayers} mapType={mapType} />
                </div>
            </div>
        </div>
    );
};

export default LegendPopup;